import React, { useState } from "react";
import { WelcomeOverlay } from "@/components/WelcomeOverlay";
import { OnboardingTour } from "@/components/OnboardingTour/OnboardingTour";
import { LocationDetailsStep } from "@/components/OnboardingTour/LocationDetailsStep";

export interface OnboardingFlowProps {
  onComplete: () => void;
}

type OnboardingPhase = "welcome" | "tour" | "location";

/**
 * Orchestrates the full first-login onboarding experience:
 * welcome screen -> feature tour -> location confirmation -> onComplete.
 */
export const OnboardingFlow: React.FC<OnboardingFlowProps> = ({
  onComplete,
}) => {
  const [phase, setPhase] = useState<OnboardingPhase>("welcome");

  if (phase === "welcome") {
    return <WelcomeOverlay onGetStarted={() => setPhase("tour")} />;
  }

  if (phase === "tour") {
    return (
      <OnboardingTour
        onBack={() => setPhase("welcome")}
        onFinish={() => setPhase("location")}
      />
    );
  }

  return (
    <LocationDetailsStep
      onBack={() => setPhase("tour")}
      onFinish={onComplete}
    />
  );
};

export default OnboardingFlow;
